import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

document.addEventListener('DOMContentLoaded', function () {
  // Warranty product ID (replace with your warranty product's ID)
  const WARRANTY_ID = 47465271722209; // replace this
  const MAIN_PRODUCT_ID = 47285852438753; // replace this

  // Check if main product is added
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function () {
      const formData = new FormData(form);
      const productId = formData.get('id');

      // If main product was added, also add warranty
      if (productId == MAIN_PRODUCT_ID) {
        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            id: WARRANTY_ID,
            quantity: 1
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Warranty product ID (replace with your warranty product's ID)
  const WARRANTY_ID = 47465271722209; // replace this
  const MAIN_PRODUCT_ID = 47404066046177; // replace this

  // Check if main product is added
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function () {
      const formData = new FormData(form);
      const productId = formData.get('id');

      // If main product was added, also add warranty
      if (productId == MAIN_PRODUCT_ID) {
        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify({
            id: WARRANTY_ID,
            quantity: 1
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        });
      }
    });
  });
});